(function () {
  'use strict';

  var MAX_GALLERY_IMAGES = 4;
  var PLACEHOLDER_LABEL = 'Product preview';
  var PLACEHOLDER_SVG =
    '<svg viewBox="0 0 64 64" aria-hidden="true" focusable="false">' +
    '<rect x="10" y="14" width="44" height="36" rx="10"></rect>' +
    '<path d="M20 24h24"></path>' +
    '<path d="M20 32h16"></path>' +
    '<path d="M20 40h10"></path>' +
    '</svg>';

  function formatMoney(amount, currency) {
    var value = Number(amount);
    var normalizedCurrency = (currency || 'AUD').toUpperCase();

    if (!Number.isFinite(value)) {
      return '';
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: normalizedCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value) + ' ' + normalizedCurrency;
    } catch (e) {
      return '$' + value.toFixed(2) + ' ' + normalizedCurrency;
    }
  }

  function getImageSource(image) {
    if (!image) {
      return '';
    }

    if (typeof image === 'string') {
      return image;
    }

    return image.src || image.url || '';
  }

  function enableTouchGallery(gallery) {
    var startX = 0;
    var startY = 0;
    var startScrollLeft = 0;
    var lockedAxis = '';
    var isTouching = false;
    var suppressClick = false;

    function resetGesture() {
      lockedAxis = '';
      isTouching = false;
      gallery.classList.remove('is-dragging');
      window.setTimeout(function () {
        suppressClick = false;
      }, 0);
    }

    gallery.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches || event.touches.length !== 1) return;

        var touch = event.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        startScrollLeft = gallery.scrollLeft;
        lockedAxis = '';
        isTouching = true;
        suppressClick = false;
      },
      { passive: true }
    );

    gallery.addEventListener(
      'touchmove',
      function (event) {
        if (!isTouching || !event.touches || event.touches.length !== 1) return;

        var touch = event.touches[0];
        var deltaX = touch.clientX - startX;
        var deltaY = touch.clientY - startY;
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);

        if (!lockedAxis) {
          if (absX < 8 && absY < 8) return;
          lockedAxis = absX > absY ? 'x' : 'y';
        }

        if (lockedAxis !== 'x') {
          return;
        }

        suppressClick = absX > 10;
        gallery.classList.add('is-dragging');
        gallery.scrollLeft = startScrollLeft - deltaX;
        event.preventDefault();
      },
      { passive: false }
    );

    gallery.addEventListener('touchend', resetGesture, { passive: true });
    gallery.addEventListener('touchcancel', resetGesture, { passive: true });
    gallery.addEventListener(
      'click',
      function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }

  function buildGallery(product) {
    var media = document.createElement('div');
    media.className = 'concern-finder__card-media';

    var images = (product.images || [])
      .map(getImageSource)
      .filter(Boolean)
      .slice(0, MAX_GALLERY_IMAGES);
    var featuredImage = getImageSource(product.featured_image);

    if (!images.length && featuredImage) {
      images = [featuredImage];
    }

    if (!images.length) {
      var placeholder = document.createElement('div');
      placeholder.className = 'concern-finder__card-placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.innerHTML = PLACEHOLDER_SVG + '<span>' + PLACEHOLDER_LABEL + '</span>';
      media.appendChild(placeholder);
      return media;
    }

    var gallery = document.createElement('div');
    gallery.className = 'concern-finder__card-gallery';

    images.forEach(function (image) {
      var img = document.createElement('img');
      var src = image;
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
      img.alt = product.title;
      img.loading = 'lazy';
      img.width = 400;
      img.height = 400;
      gallery.appendChild(img);
    });
    enableTouchGallery(gallery);
    media.appendChild(gallery);

    if (images.length <= 1) {
      return media;
    }

    var count = document.createElement('span');
    count.className = 'concern-finder__card-count';
    count.textContent = '1/' + images.length;
    media.appendChild(count);

    var dots = document.createElement('div');
    dots.className = 'concern-finder__card-dots';
    var dotEls = images.map(function (_, index) {
      var dot = document.createElement('span');
      dot.className = 'concern-finder__card-dot' + (index === 0 ? ' is-active' : '');
      dots.appendChild(dot);
      return dot;
    });
    media.appendChild(dots);

    var ticking = false;
    gallery.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var index = Math.max(0, Math.min(Math.round(gallery.scrollLeft / gallery.clientWidth), images.length - 1));
          count.textContent = index + 1 + '/' + images.length;
          dotEls.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === index);
          });
          ticking = false;
        });
      },
      { passive: true }
    );

    return media;
  }

  function addToCart(variantId, button) {
    if (!window.routes || !window.routes.cart_add_url) {
      window.location = '/cart/add?id=' + variantId + '&quantity=1';
      return;
    }

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var originalText = button.textContent;
    button.setAttribute('aria-disabled', 'true');
    button.disabled = true;
    button.textContent = 'Adding…';

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'Could not add to cart');
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'shop-by-concern-finder',
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        }

        button.textContent = '✓ Added';
        button.classList.add('is-added');
        setTimeout(function () {
          button.textContent = originalText;
          button.classList.remove('is-added');
          button.disabled = false;
          button.removeAttribute('aria-disabled');
        }, 1600);
      })
      .catch(function () {
        button.textContent = 'Try again';
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
          button.removeAttribute('aria-disabled');
        }, 1600);
      });
  }

  function buildCard(product) {
    var variant = (product.variants && product.variants[0]) || {};
    var price = variant.price !== undefined && variant.price !== null && variant.price !== ''
      ? formatMoney(variant.price, window.Shopify && Shopify.currency ? Shopify.currency.active : 'AUD')
      : '';
    var addToCartLabel = price ? 'Add to cart (' + price + ')' : 'Add to cart';

    var card = document.createElement('div');
    card.className = 'concern-finder__card';

    var link = document.createElement('a');
    link.className = 'concern-finder__card-link';
    link.href = '/products/' + product.handle;

    link.appendChild(buildGallery(product));

    var title = document.createElement('p');
    title.className = 'concern-finder__card-title';
    title.textContent = product.title;
    link.appendChild(title);

    card.appendChild(link);

    var atc = document.createElement('button');
    atc.type = 'button';
    atc.className = 'concern-finder__card-atc';
    if (variant.available === false || !variant.id) {
      atc.textContent = 'Out of stock';
      atc.disabled = true;
    } else {
      atc.textContent = addToCartLabel;
      atc.addEventListener('click', function () {
        addToCart(variant.id, atc);
      });
    }
    card.appendChild(atc);

    return card;
  }

  function ConcernFinder(root) {
    this.root = root;
    this.options = Array.prototype.slice.call(root.querySelectorAll('[data-collection]'));
    this.results = root.querySelector('[data-results]');
    this.grid = root.querySelector('[data-grid]');
    this.loading = root.querySelector('[data-loading]');
    this.error = root.querySelector('[data-error]');
    this.resultsTitle = root.querySelector('[data-results-title]');
    this.viewAll = root.querySelector('[data-view-all]');
    this.resetBtn = root.querySelector('[data-reset]');
    this.limit = parseInt(root.getAttribute('data-results-limit'), 10) || 8;
    this.cache = {};

    this.options.forEach(
      function (btn) {
        btn.addEventListener('click', this.onSelect.bind(this, btn));
      }.bind(this)
    );

    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', this.reset.bind(this));
    }
  }

  ConcernFinder.prototype.onSelect = function (btn) {
    this.options.forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
    });
    btn.setAttribute('aria-pressed', 'true');

    var handle = btn.getAttribute('data-collection');
    var label = btn.getAttribute('data-label');

    this.results.hidden = false;
    this.results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    this.resultsTitle.textContent = label;
    this.viewAll.href = '/collections/' + handle;
    this.grid.innerHTML = '';
    this.error.hidden = true;
    this.loading.hidden = false;

    this.load(handle)
      .then(
        function (products) {
          this.loading.hidden = true;
          if (!products || !products.length) {
            this.error.hidden = false;
            return;
          }
          var frag = document.createDocumentFragment();
          products.slice(0, this.limit).forEach(
            function (product) {
              frag.appendChild(buildCard(product));
            }.bind(this)
          );
          this.grid.appendChild(frag);
        }.bind(this)
      )
      .catch(
        function () {
          this.loading.hidden = true;
          this.error.hidden = false;
        }.bind(this)
      );
  };

  ConcernFinder.prototype.load = function (handle) {
    if (this.cache[handle]) {
      return Promise.resolve(this.cache[handle]);
    }
    var url = '/collections/' + handle + '/products.json?limit=' + Math.max(this.limit, 8);
    return fetch(url)
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Failed to fetch collection ' + handle);
        }
        return res.json();
      })
      .then(
        function (data) {
          var products = (data && data.products) || [];
          this.cache[handle] = products;
          return products;
        }.bind(this)
      );
  };

  ConcernFinder.prototype.reset = function () {
    this.options.forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
    });
    this.results.hidden = true;
    this.grid.innerHTML = '';
  };

  document.querySelectorAll('[data-shop-by-concern-finder]').forEach(function (root) {
    new ConcernFinder(root);
  });
})();
